import React, { useState } from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import { PageContainer } from 'components/shared';
import WebmasterTools from './webmastertools';
import RobotsTxt from './robotstxt';
import Sitemap from './sitemap';
import RobotsMetaContent from './robotsmetacontent';
import Logs from './404logs';

const SEOSettings = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageContainer
      title="SEO Settings"
      subtitle="Manage webmaster tools, robots.txt, sitemap, meta content and 404 logs"
    >
      <Paper>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="SEO Settings Tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Webmaster Tools" />
            <Tab label="Robots.txt" />
            <Tab label="Sitemap" />
            <Tab label="Robots Meta Content" />
            <Tab label="404 Logs" />
          </Tabs>
        </Box>
        <Box sx={{ p: 3 }}>
          {value === 0 && <WebmasterTools />}
          {value === 1 && <RobotsTxt />}
          {value === 2 && <Sitemap />}
          {value === 3 && <RobotsMetaContent />}
          {value === 4 && <Logs />}
        </Box>
      </Paper>
    </PageContainer>
  );
};

export default SEOSettings;
